import {
	defaultTqcInspectResultDtlDto,
	defaultTqcInspectResultHdrDto,
	TqcInspectResultDtlDto,
	TqcInspectResultHdrDto,
} from "src/dtos/tqcInspectResult/tqcInspectResultDto";
import { TQCInspectSpecDto } from "src/dtos/tqcInspectSpec/tqcInspectSpecDto";

/** tqc_inspect_result_hdr 기반의 월별 측정 헤더 정보 */
export interface TQC2100_R01HeaderDto extends TqcInspectResultHdrDto {
	inserted: boolean;
	isModified: boolean;
}

export const defaultTQC2100_R01HeaderDto: TQC2100_R01HeaderDto = {
	...defaultTqcInspectResultHdrDto,
	inspectType: "FPI",
	inspectTypeNm: "초품검사",
	inserted: false,
	isModified: false,
};

/** MS/FPI 검사기준으로부터 조회한 점검내용 마스터 */
export interface TQC2100_R01InspectMasterDto extends TQCInspectSpecDto {}

/** 서버 저장·조회에 사용하는 검사기준코드와 측정일자 단위의 상세 정보 */
export interface TQC2100_R01DetailDto
	extends TqcInspectResultDtlDto {
	inspItemGroup: string;
	inspType: string;
	inspItemCd: string;
	inspItemNm: string;
	measureValue: string;
	compCd: string;
	inspectorEmp: string;
	inspectorEmpNm: string;
	approvorEmpno: string;
	approvorEmpNm: string;
	headerRemark: string;
	inserted: boolean;
	isModified: boolean;
}

export const defaultTQC2100_R01DetailDto: TQC2100_R01DetailDto = {
	...defaultTqcInspectResultDtlDto,
	inspectDt: undefined,
	inspItemGroup: "MS",
	inspType: "FPI",
	inspItemCd: "",
	inspItemNm: "",
	measureValue: "",
	compCd: "",
	inspectorEmp: "",
	inspectorEmpNm: "",
	approvorEmpno: "",
	approvorEmpNm: "",
	headerRemark: "",
	inserted: false,
	isModified: false,
};

export type TQC2100_R01CellValue = string;

/** 화면 그리드에서 점검내용을 행, 날짜를 열로 표현하는 피벗 정보 */
export interface TQC2100_R01DetailPivotDto {
	valueIndex: number;
	inspItemGroup: string;
	inspType: string;
	inspItemCd: string;
	inspItemNm: string;
	dayValues: Record<string, TQC2100_R01CellValue>;
	dayMeta: Record<string, { itemNo?: string }>;
	isModified?: boolean;
	inserted?: boolean;
}

export const defaultTQC2100_R01DetailPivotDto: TQC2100_R01DetailPivotDto = {
	valueIndex: 0,
	inspItemGroup: "MS",
	inspType: "FPI",
	inspItemCd: "",
	inspItemNm: "",
	dayValues: {},
	dayMeta: {},
	isModified: false,
};
